export default __webpack_public_path__ + "static/media/Logo_Hilfetelefon.81842e3b.jpg";